import AccountsAPI from "@/api/apiAccounts";
import * as settings from "@/config/settings";

const getCredentialsFromLocalStorage = () => {
  let storedCredentials = localStorage.getItem(
    settings.LOCALSTORAGE.credentials
  );
  if (storedCredentials) {
    storedCredentials = JSON.parse(storedCredentials);
  }
  return storedCredentials;
};

export const namespaced = true;

export const state = {
  credentials: getCredentialsFromLocalStorage()
};

export const getters = {
  isLoggedIn(state) {
    return state.credentials != null;
  },
  currentUser(state) {
    return state.credentials ? state.credentials.user : null;
  }
};

export const mutations = {
  SET_CREDENTIALS(state, credentials) {
    state.credentials = credentials;
    if (credentials === null) {
      localStorage.removeItem(settings.LOCALSTORAGE.credentials);
    } else {
      localStorage.setItem(
        settings.LOCALSTORAGE.credentials,
        JSON.stringify(credentials)
      );
    }
  },
  SET_USER_DETAILS(state, user) {
    state.credentials.user = user;
  },
  REGISTER(state, registration) {
    state.registration = registration;
  }
};

export const actions = {
  // global
  init: {
    root: true,
    async handler({ commit, dispatch }) {
      const credentials = getCredentialsFromLocalStorage();
      commit("SET_CREDENTIALS", credentials);
      await dispatch("login", credentials);
    }
  },
  // namespaced
  async login({ commit }, credentials) {
    try {
      let response = await AccountsAPI.login(credentials);
      commit("SET_CREDENTIALS", response);
    } catch (e) {
      commit("SET_CREDENTIALS", null);
      throw e;
    }
  },
  logout({ commit }) {
    commit("SET_CREDENTIALS", null);
  },
  async register({ commit }, data) {
    commit("REGISTER", data);
    let response = await AccountsAPI.register(data);
    return response;
  },
  async changeUserDetails({ commit }, data) {
    let response = await AccountsAPI.changeUserDetails(data);
    commit("SET_USER_DETAILS", response);
    return response;
  },
  async changePassword(_, data) {
    let response = await AccountsAPI.changePassword(data);
    return response;
  },
  async resetPassword(_, data) {
    let response = await AccountsAPI.resetPassword(data);
    return response;
  },
  async requestResetPassword(_, data) {
    let response = await AccountsAPI.requestResetPassword(data);
    return response;
  }
};
